import { MockPaymentStruct } from "graphql/__generated__/globalTypes";
import _ from "lodash";
import numeral from "numeral";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Show from "../../../components/core/show";

type Props = {
  payments: (MockPaymentStruct | null)[] | null | undefined;
};

const OfferPayments = ({ payments }: Props) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <div className="mt-8 flex flex-col">
        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="overflow-hidden ring-1 ring-black ring-opacity-5">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      {t("payments.payment_type")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("payments.bank_name")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("payments.beneficiary_bank_name")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("payments.payment_amount")}
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      {t("payments.payment_date")}
                    </th>
                    {/* <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Last Payment Upate
                    </th> */}
                    {/* <th
                      scope="col"
                      className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                    >
                      <span className="sr-only">Edit</span>
                    </th> */}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {payments?.map((payment, idx) => {
                    if (!payment?.paid_details) return null;
                    const pd = payment.paid_details;
                    const details = JSON.parse(pd) as any;
                    return (
                      <tr key={idx}>
                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          <Show if={details?.payment_type === "Cheque"}>
                            {details?.payment_type ?? "N/A"}
                            {" - "}
                            {_.get(details.payment_from, "cheque_number", null)}
                          </Show>

                          <Show if={details?.payment_type !== "Cheque"}>
                            {details?.payment_type ?? "N/A"}{" "}
                          </Show>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {details?.payment_from?.bank_name ?? "N/A"}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {details?.payment_to ?? "N/A"}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {numeral(payment?.offer_payment_amount).format(
                            "#,#.##"
                          )}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {(() => {
                            const dateStr = payment?.date_of_distribution ?? payment?.created_at;
                            if (!dateStr) return "N/A";

                            const date = new Date(dateStr);
                            const formattedDate = date.toLocaleDateString('en-CA'); // YYYY-MM-DD format
                            const formattedTime = date.toLocaleTimeString('en-US', {
                              hour: 'numeric',
                              minute: '2-digit',
                              hour12: true
                            });

                            return `${formattedDate} ${formattedTime}`;
                          })()}
                        </td>
                        {/* <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          Member
                        </td> */}
                        {/* <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                          <span className="text-indigo-600 hover:text-indigo-900">
                            View
                          </span>
                        </td> */}
                      </tr>
                    );
                  })}

                  {/* <!-- More people... --> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OfferPayments;
